module.exports = __webpack_public_path__ + "131276a9ac486716e9ced9cb58a06c90.svg";